// Approach borrowed from:
// https://www.reddit.com/r/nextjs/comments/1jlf8g6/comment/mk42xnc/
//
// Imported from the internal entry to avoid the tsconfig `next/link` alias
// looping back to this file. This path is not part of Next.js's public API —
// re-verify on Next.js major upgrades. Also note: vitest does not read tsconfig
// paths, so tests resolve `next/link` to the real module (prefetch default
// `true`); add an explicit alias in `vitest.config.mjs` if a test ever needs to
// observe the override behaviour.
import NextLink from 'next/dist/client/link';
import type { ComponentPropsWithRef } from 'react';
export type { LinkProps } from 'next/dist/client/link';
const Link = (props: ComponentPropsWithRef<typeof NextLink>) => <NextLink prefetch={false} {...props} data-sentry-element="NextLink" data-sentry-component="Link" data-sentry-source-file="link.tsx" />;
Link.displayName = 'Link';
export default Link;